/**
 * @requires HBS
 */
(function() {
	/**
	 * @exports DKA.main
	 */
	let module = {};

	/**
	 * Global init code for the whole application
	 */
	module.init = () => {
        jQuery('.nav-tabs a').on('click', function (e) {
            e.preventDefault();  
            var tabId = jQuery(this).attr('href');
            jQuery('.nav-link, .considerations__content').removeClass('active');
            jQuery(tabId).addClass('active');
            jQuery(this).addClass('active');
        })

        jQuery('.js-accordion-trigger').on('click', function (e) {
            if(jQuery(this).children().hasClass('active')){
                jQuery(this).children().removeClass('active');
            } else{
                jQuery('.js-accordion-trigger').children().removeClass('active');
                jQuery(this).children().addClass('active');
            }           
        })

        //unlcok continute button upon facility type selection.
        jQuery('.js-facility-selector').on('click', function (e) {
                jQuery('.js-facility-selector').removeClass('selected');
                jQuery(this).addClass('selected');
                jQuery('.js-facility-selector-btn').removeClass('disabled');
                var facility = jQuery(this).data('facility');
                jQuery('.js-facility-selector-link').attr("href", "/knowledge-center/?facility="+facility); 
        })

        jQuery('.js-video').on('click', function (e) {
            e.preventDefault();
            var videoID = jQuery(this).data('video');
            jQuery('.js-video-iframe').attr("src", "https://www.youtube.com/embed/"+videoID); 
            MicroModal.show('modal-video');
        })

        //add to gateway submit actions
        // jQuery(document).on('gform_confirmation_loaded', function(event, formId){
        //     document.cookie = "gateway=open";
        //     MicroModal.close('modal-gateway');
        //     jQuery('.js-gateway').off('click');
        //     jQuery('.js-gateway .file__title').removeClass("locked").addClass("unlocked");
            
        // });

        function getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for(var i = 0; i <ca.length; i++) {
              var c = ca[i];
              while (c.charAt(0) == ' ') {
                c = c.substring(1);
              }
              if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
              }
            }
            return "";
        }

        if(!(getCookie('gateway')=="open")){
            //show gateway form if no cookie
            jQuery('.js-gateway').on('click', function (e) {           
                e.preventDefault();
                var modal = jQuery(this).data('modal');
                MicroModal.show(modal);            
            })
        }else{
            jQuery('.js-gateway .file__title').removeClass("locked").addClass("unlocked");
        }

        //success redirect modal       
        var hash = window.location.hash;
        if(hash == "#confirmation"){
            MicroModal.show("modal-gateway-success");
        }

        var startOver = jQuery('[data-startover]');
        startOver.on('click', function(e){
            e.preventDefault();

            if (window.confirm("Are you sure you want to discard your current configuration and start over?")) {
                location.href = this.href;
            }
        });

        // Anchor Links Smooth Scrolling
        // Select all links with hashes
        jQuery('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function(event) {
        if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
            && 
            location.hostname == this.hostname
        ) {
            var target = jQuery(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            jQuery('html, body').animate({
                scrollTop: target.offset().top
            }, 500, function() {
                // Callback after animation
                // Must change focus!
                var $target = jQuery(target);
                $target.focus();
                if ($target.is(":focus")) { // Checking if the target was focused
                return false;
                } else {
                $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
                };
            });
            }
        }
        });
    };   


	/**
	 * Initialize the app and run the bootstrapper
	 */
	 var docReady = (callback) => {
        // in case the document is already rendered
        if (document.readyState !== 'loading') {
            callback();
        } else if (document.addEventListener) {
            // modern browsers
            document.addEventListener('DOMContentLoaded', callback);
        } else {
            // IE <= 8
            document.attachEvent('onreadystatechange', () => {
                if (document.readyState === 'complete') callback();
            });
        }
    };

    docReady(() => {
        module.init();
        HBS.initPage();
    });

	HBS.namespace('DKA.main', module);
}());